import React, { FC } from 'react';

import Loader from 'crehana-ui/Loader';
import Dialog from 'crehana-ui/Dialog';
import Text from 'crehana-ui/Text';
import Price from 'crehana-ui/Text/Price';
import { UserType } from 'Jsx/Types/UserType';
import { primaryMain } from 'crehana-ui/styles/colors';
import Check from 'crehana-icons/Check';

import { usePricesContext } from 'Jsx/CourseDetail/Context/Prices';

import modalData from './strings';
import { Course } from '../../../types';

interface LessonModalProps {
  lessonModal: boolean;
  hideModal(): void;
  course: Course;
  user: UserType;
  BuyButtons: React.ReactElement;
}

const LessonModal: FC<LessonModalProps> = ({
  lessonModal,
  hideModal,
  course: { title },
  user,
  BuyButtons,
}) => {
  const { loading, prices } = usePricesContext();

  if (loading || !prices) {
    return (
      <Dialog size="s" open={lessonModal} onDismiss={hideModal}>
        <div className="flex items-center justify-center min-h-200">
          <Loader />
        </div>
      </Dialog>
    );
  }

  const { price, discount, currencySymbol, realPrice } = prices;

  return (
    <Dialog size="s" open={lessonModal} onDismiss={hideModal}>
      <div data-cy="lessons-dialog-to-buy-course" className="py-40 px-20">
        {!(user && user.isPremiumMember) && price > 0 && (
          <div>
            <div className="flex flex-col text-center mb-16">
              <Text type="h4" className="mb-8">
                {modalData.title}
              </Text>
              <Text>{modalData.subtitle}</Text>
            </div>
            <div className="flex flex-col">
              {modalData.benefits.map(c => (
                <div className="flex items-center mb-8" key={c}>
                  <Check color={primaryMain} size={12} />
                  <Text className="ml-8">{c}</Text>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="flex flex-col items-center mt-16">
          <Text type="subtitle3" className="mb-8">
            {title}
          </Text>
          {user && user.isPremiumMember ? null : price === 0 ? (
            <Text>CURSO GRATIS</Text>
          ) : (
            <div className="flex items-end">
              <Price
                currency={currencySymbol}
                price={price}
                realPrice={realPrice}
                discount={discount > 0 ? `${discount}%` : undefined}
              />
            </div>
          )}
        </div>
        <div className="flex flex-col mt-16 items-center justify-center">
          <div className="w-full sm:w-auto sm:mr-auto sm:ml-auto">
            {BuyButtons}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default LessonModal;
